// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_EqG","cls2":"DebugPage-cls2_INJ DebugPage-cls1_EqG"};